/**
 * @module core
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 * A T-mobile custom service to integrate with window matchmedia to detect device width
 */ /** */
// TODO: incomplete logic
import { Injectable } from '@angular/core';

@Injectable()
export class MatchmediaService {
  constructor() {}

  public isDesktop(): boolean {
    return window.matchMedia('(min-width: 992px)').matches;
  }
  // need to check with HTML team for specifications
  public isTablet(): boolean {
    return window.matchMedia('(min-width: 768px) and (max-width: 991px)').matches;
  }
  // need to check with HTML team for specifications
  public isPhone(): boolean {
    return window.matchMedia('(max-width: 767px)').matches;
  }
}
